import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Homepage from '../containers/Homepage';
import NavBar from '../components/NavBar/NavBar';
import NavBarItems from '../components/NavBar/NavBarItems';
import AdverchaApp from '../containers/AdverchaApp';

const Root = () => (
  <>
    <NavBar config={NavBarItems()}>
      <Switch>
        <Route path="/app" component={AdverchaApp} />
        <Route path="/" component={Homepage} />
      </Switch>
    </NavBar>
  </>
);
export default Root;
